/**
 * Public FAQ index.
 * @viewport both
 */
import React, { useMemo, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Breadcrumbs,
  Link,
  TextField,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import HelpPublicLayout from '@/features/help/components/HelpPublicLayout';
import { AUTH_HELP_FAQ, AUTH_HELP_PATHS } from '@/features/help/helpContent';

const HelpFaqPage = () => {
  const [query, setQuery] = useState('');
  const filtered = useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return AUTH_HELP_FAQ;
    return AUTH_HELP_FAQ.filter(
      (item) =>
        item.question.toLowerCase().includes(q) ||
        item.answer.toLowerCase().includes(q) ||
        item.category.toLowerCase().includes(q)
    );
  }, [query]);

  return (
    <HelpPublicLayout
      title="Frequently asked questions"
      subtitle="Signing up, roles, manager participation, and account approval"
    >
      <Breadcrumbs sx={{ mb: 2 }}>
        <Link component={RouterLink} to={AUTH_HELP_PATHS.hub} underline="hover" color="inherit">
          Help
        </Link>
        <Typography color="text.primary">FAQ</Typography>
      </Breadcrumbs>

      <TextField
        fullWidth
        size="small"
        label="Search FAQ"
        value={query}
        onChange={(e) => setQuery(e.target.value)}
        sx={{ mb: 2 }}
      />

      {filtered.map((item) => (
        <Accordion key={item.slug} disableGutters variant="outlined" sx={{ mb: 1 }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Box>
              <Typography variant="caption" color="text.secondary">
                {item.category}
              </Typography>
              <Typography variant="subtitle2">{item.question}</Typography>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <Typography variant="body2" paragraph>
              {item.answer}
            </Typography>
            <Link
              component={RouterLink}
              to={`${AUTH_HELP_PATHS.faq}/${item.slug}`}
              variant="body2"
            >
              Permalink
            </Link>
          </AccordionDetails>
        </Accordion>
      ))}

      {filtered.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No matches. Try a different search term.
        </Typography>
      ) : null}
    </HelpPublicLayout>
  );
};

export default HelpFaqPage;
